import { fomo } from '../constants/fomo';
import { IFomo } from '../types/fomo';

const getRandomString = (array: string[]) => {
  const randomIndex = Math.floor(Math.random() * array.length);
  return array[randomIndex];
};

const imageArray: string[] = [
  'https://uploads-ssl.webflow.com/64bfa5e0facc755c5e415e1b/64bfc678772b2c24b04208a2_bundle1.png',
  'https://uploads-ssl.webflow.com/64bfa5e0facc755c5e415e1b/64bfc67873964b051ab1c9c5_bundle2.png',
  'https://uploads-ssl.webflow.com/64bfa5e0facc755c5e415e1b/64bfc67877d242c996e64602_bundle3.png',
  'https://uploads-ssl.webflow.com/64bfa5e0facc755c5e415e1b/64bfc67875299ea875b3cc26_bundle4.png',
];

export const createFomoNotification = (
  productName?: string,
  images?: string[],
  maxProductQuantity = 3,
): IFomo => {
  const country = window.GEO.country;
  const fomoLocation = getRandomString(fomo.cities[country] || fomo.cities.US);
  const fomoName = getRandomString(fomo.names[country] || fomo.names.US);
  const fomoMinutes = Math.floor(Math.random() * 30) + 1;
  const number = Math.floor(Math.random() * maxProductQuantity) + 2;
  const fomoImage = images ? images[number - 1] : imageArray[number - 1];
  const fomoProduct = `${number}${productName || 'x Bandoo Box'}`;

  return {
    fomoMinutes: fomoMinutes.toString(),
    fomoLocation,
    fomoProduct,
    fomoImage,
    fomoName,
  };
};

export const createProductsFomoNotification = (
  products: any[],
  productName: string,
): IFomo => {
  const country = window.GEO.country;
  const fomoLocation = getRandomString(fomo.cities[country] || fomo.cities.US);
  const fomoName = getRandomString(fomo.names[country] || fomo.names.US);
  const fomoMinutes = Math.floor(Math.random() * 30) + 1;

  const randomIndex = Math.floor(Math.random() * products.length);
  const randomProduct = products[randomIndex];

  const fomoImage = randomProduct?.imageReference || randomProduct?.image;
  const fomoProduct = `${randomProduct?.quantity || 1}${productName}`;

  const notification = {
    fomoMinutes: fomoMinutes.toString(),
    fomoLocation,
    fomoProduct,
    fomoImage,
    fomoName,
  };

  return notification;
};
